import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NZ_I18N, NZ_ICONS, zh_CN, NzSpinModule, NzNotificationService} from 'ng-zorro-antd';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {registerLocaleData} from '@angular/common';
import zh from '@angular/common/locales/zh';
import {LayoutModule} from './layout/layout.module';
import {LoginModule} from './login/login.module';
import {ANT_ICONS} from '../ant-icons';
import {PipesModule} from './pipes/pipes.module';
import {DirectiveModule} from './directives/directive.module';
import {MomentModule} from 'ngx-moment';
import {ApiConfig, ApiModule} from '@velites/ng-api';
import {GLOBAL_STATE_LOCAL_STORAGE_PROVIDER, API_STATE_LOCAL_STORAGE_PROVIDER, XskBasisModule, INJECTION_TOKEN_ENVIRONMENT_WITH_BUILD} from '@xsk/ng-basis'
import {environment} from '@environment';
import {TestModule} from './features/test/test.module';
import {NgxAmapModule} from 'ngx-amap';

registerLocaleData(zh);

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    XskBasisModule,
    ApiModule,
    AppRoutingModule,
    LayoutModule,
    BrowserAnimationsModule,
    LoginModule,
    MomentModule,
    PipesModule,
    DirectiveModule,
    NzSpinModule,
    TestModule,
    NgxAmapModule.forRoot({
      apiKey: environment.variables.mapApiKey
    }),
  ],
  providers: [
    {provide: NZ_I18N, useValue: zh_CN},
    {provide: NZ_ICONS, useValue: ANT_ICONS},
    { provide: INJECTION_TOKEN_ENVIRONMENT_WITH_BUILD, useValue: environment },
    {provide: ApiConfig, useValue: {root: environment.apiRoot}},
    NzNotificationService,
    GLOBAL_STATE_LOCAL_STORAGE_PROVIDER, API_STATE_LOCAL_STORAGE_PROVIDER
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
